import { render, staticRenderFns } from "./luckydrawlist.vue?vue&type=template&id=56b0a654&"
import script from "./luckydrawlist.vue?vue&type=script&lang=js&"
export * from "./luckydrawlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports